// Copyright 2022-2026 - Hewlett Packard Enterprise Company
import type React from 'react';
import { Box, Text } from 'grommet';
import LoadingSpinner from './LoadingSpinner';

interface Props {
  size?: string;
  label?: string;
  orientation?: 'horizontal' | 'vertical';
}

const LoadingSpinnerWithText: React.FC<Props> = ({
  size,
  label,
  orientation,
}) => (
  <Box
    align="center"
    justify="center"
    width={orientation === 'vertical' ? size : undefined}
    direction={orientation === 'horizontal' ? 'row' : 'column'}
    gap={orientation === 'horizontal' ? 'xsmall' : undefined}
  >
    <Box align="center" justify="center" width={size} height={size}>
      <LoadingSpinner />
    </Box>

    {label && <Text>{label}</Text>}
  </Box>
);

export default LoadingSpinnerWithText;
